import { GRAY_400, GRAY_900 } from 'constants/styling/theme'
import { Stack, Typography } from '@mui/material'

import { AnalyticsEvent, logAnalyticsEvent } from 'utils/analytics'

import { FC } from 'react'
import { MUIButton } from 'components/common/MUIButton'
import { externalNavigate } from 'utils/helpers'
import { Path } from 'constants/router'
import { useCreativeUploadPage } from './_main'
import { useTranslation } from 'react-i18next'

/** Lookalike of Adobe's Lightroom Classic app icon */
const LightroomBadge: FC = () => (
  <svg viewBox="0 0 40 40" width="28" height="28" aria-hidden="true" style={{ flexShrink: 0 }}>
    <rect width="40" height="40" rx="8" fill="#001E36" />
    <text x="20" y="26.5" textAnchor="middle" fontFamily="'Source Sans 3', 'Helvetica Neue', Arial, sans-serif" fontWeight="600" fontSize="16" letterSpacing="-0.3" fill="#31A8FF">LrC</text>
  </svg>
)

/**
 * Offers publishing from Lightroom Classic with the Backbone plugin.
 * The guide (`/lightroom-plugin`) carries the plugin download, so the button leads there rather than to the zip.
 * @example <LightroomPublishRow />
 */
export const LightroomPublishRow: FC = () => {
  const { t } = useTranslation(['ct_upload_page'])
  const { assignmentId } = useCreativeUploadPage()

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      flexWrap="wrap"
      gap={1.5}
      pt={3}
      borderTop={`1px solid ${GRAY_400}`}
    >

      <LightroomBadge />

      <Typography variant="text-md" fontWeight={500} color={GRAY_900}>
        {t('lightroom_guide.title')}
      </Typography>

      <MUIButton
        type="secondaryBorder"
        size="sm"
        // New tab: leaving this page mid-upload would interrupt the browser uploads
        onClick={() => {
          logAnalyticsEvent(AnalyticsEvent.LIGHTROOM_GUIDE_OPENED, { assignmentId })
          externalNavigate(Path.LIGHTROOM_PLUGIN_GUIDE)
        }}
      >
        {t('lightroom_guide.download')}
      </MUIButton>

    </Stack>
  )
}
